import { FC, useEffect, useRef, useState } from 'react';
import styled from './index.module.scss';
import { RePlayIcon, PlayIcon, PauseIcon } from '@/components/XPower/svg';

interface IProps {
    src: string;
    h5?: string;
}

type IVideoStatus = 'play' | 'pause' | 'end';

const Video: FC<IProps> = ({ src, h5 }) => {
    const videoRef1 = useRef<HTMLVideoElement>(null);
    const videoRef2 = useRef<HTMLVideoElement>(null);
    const [status, setStatus] = useState<IVideoStatus>('play');

    const handlePlay = () => {
        videoRef1?.current?.play();
        videoRef2?.current?.play();
        setStatus('play');
    };

    const handlePause = () => {
        videoRef1?.current?.pause();
        videoRef2?.current?.pause();
        setStatus('pause');
    };

    useEffect(() => {
        const ref1 = videoRef1.current;
        const ref2 = videoRef2.current;

        const onEnd = () => {
            setStatus('end');
        };
        ref1?.addEventListener('ended', onEnd);
        ref2?.addEventListener('ended', onEnd);
        return () => {
            ref2?.removeEventListener('ended', onEnd);
            ref2?.removeEventListener('ended', onEnd);
        };
    }, [videoRef1, videoRef2]);

    return (
        <div className={styled.Video}>
            {src && (
                <video ref={videoRef1} playsInline muted autoPlay className={h5 ? 'lowcode-video-pc' : ''}>
                    <source src={src} />
                </video>
            )}
            {h5 && (
                <video ref={videoRef2} playsInline muted autoPlay className={h5 ? 'lowcode-video-h5' : ''}>
                    <source src={h5} />
                </video>
            )}
            <div className="tools">
                {status === 'play' && <PauseIcon onClick={handlePause} />}
                {status === 'pause' && <PlayIcon onClick={handlePlay} />}
                {status === 'end' && <RePlayIcon onClick={handlePlay} />}
            </div>
        </div>
    );
};

export default Video;
